import { render, staticRenderFns } from "./UserAttributes.vue?vue&type=template&id=6c159ab4&scoped=true&"
import script from "./UserAttributes.vue?vue&type=script&lang=js&"
export * from "./UserAttributes.vue?vue&type=script&lang=js&"
import style0 from "./UserAttributes.vue?vue&type=style&index=0&id=6c159ab4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c159ab4",
  null
  
)

export default component.exports